import axios from "./axios";

export const validateVat = async (countryCode, vat) => {
  return await axios.get("/vat/validate", {
    params: {countryCode, vat}
  });
};
